import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { value } from "lodash/seq";
import { toast } from "react-toastify";
import AppModal from "../../components/Modal";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import yup from "../../utils/yup";
import Form from "../../components/form/Form";
import { getEmployments } from "../../services/EmploymentService";
import { convertDate, getCurrentUser, getFullName } from "../../utils/utils";
import {
  createRequest,
  deleteRequest,
  updateRequest,
} from "../../services/AvailabilityService";
import {
  EmploymentStatuses,
  Roles as Role,
  Roles,
} from "../../utils/constants";
import SecondaryButton from "../../components/SecondaryButton";

const RequestForm = ({
  open,
  onClose,
  setRequests,
  request,
  setAvailabilitiesModal,
}) => {
  const [employments, setEmployments] = useState([]);
  const [formDetails, setFormDetails] = useState({
    schema: null,
    details: null,
  });

  const form = useForm({
    resolver: yupResolver(formDetails.schema),
    mode: "onChange",
  });
  const watchEmployment = form.watch("employment_id");
  const user = getCurrentUser();

  useEffect(() => {
    getEmployments().then((data) =>
      setEmployments(
        data.filter(
          (i) => i.status === EmploymentStatuses.ACCEPTED.value || i.is_private
        )
      )
    );
  }, []);

  useEffect(() => {
    if (request) {
      Object.keys(request).map((i) => {
        if (["from_date", "to_date", "created_at"].includes(i)) {
          form.setValue(i, convertDate(request[i]));
        } else {
          form.setValue(i, request[i]);
        }
      });
    }
    setFormDetails({
      schema: yup
        .object()
        .shape({
          from_date: yup
            .date()
            .required("Enter a start date.")
            .typeError("Enter a start date.")
            .test(
              "start-time-past",
              "Enter a start date in the future",
              (fromDate) => {
                const currentDate = new Date();
                return fromDate.getDate() >= currentDate.getDate() && fromDate.getMonth() >= currentDate.getMonth() && fromDate.getFullYear() >= currentDate.getFullYear();
              }
            ),
          to_date: yup
            .date()
            .required("The end date is required.")
            .typeError("The end date is required.")
            .when("from_date", (fromDate, yup) => {
              if (fromDate[0] instanceof Date && !isNaN(fromDate[0])) {
                return yup.min(
                  fromDate,
                  "The end date cannot be before start date."
                );
              }
            }),
          ...(!request
            ? {
                employment_id: yup
                  .number()
                  .required("The employee field is required."),
                categories: yup
                  .array(
                    // yup.object().shape({
                    //   category_id: yup
                    //     .number()
                    //     .required("The category is required."),
                    //   note: yup.string().nullable(),
                    //   ...(user.role === Roles.EMPLOYEE.value
                    //     ? {
                    //         hours: yup
                    //           .number()
                    //           .typeError("The hours field is not valid.")
                    //           .required("The hours field is required."),
                    //       }
                    //     : {}),
                    // })
                  )
                  .required([undefined, null].includes(watchEmployment) ? "You must select an employee to view categories." : "Add at least one category.")
                  .transform((categories) => categories.map((i) => ({ "category_id": i }))),
              }
            : {}),
        })
        .required(),
      details: {
        submitButtonLabel: "Submit",
        steps: [
          ...(!request
            ? [
                {
                  name: "employment_id",
                  label: "Select an employee",
                  type: "select-text-input",
                  options: employments.filter((employment) => employment.status === EmploymentStatuses.ACCEPTED.value && employment.user)
                      .map((emp) => ({
                    value: emp.id,
                    label: getFullName(emp.user)
                      ? getFullName(emp.user)
                      : emp.identifier,
                  })),
                },
              ]
            : []),
          {
            name: "from_date",
            type: "text",
            label: "Select the starting date",
            htmlType: "date",
            disabled: request && user.id !== request.created_by,
          },
          {
            name: "to_date",
            type: "text",
            label: "Select the ending date",
            htmlType: "date",
            disabled: request && user.id !== request.created_by,
          },
            ...(!request
            ?
              [{
                name: "categories",
                type: "select-text-input",
                label: "Select work categories for the employment",
                multiple: true,
                disabled: [undefined, null].includes(watchEmployment),
                options: [undefined, null].includes(watchEmployment) ? [] : employments
                            .find((i) => i.id === watchEmployment)
                            ?.categories.map((cat) => ({
                              value: cat.id,
                              label: cat.name,
                            })),
              }]
              // [
              //   {
              //     type: "array",
              //     name: "categories",
              //     arrayLabel: [undefined, null].includes(watchEmployment)
              //       ? "Please select an employee to add categories"
              //       : employments.find((i) => i.id === watchEmployment)
              //           ?.categories.length === 0
              //       ? "You must assign a category to the employee first."
              //       : "Add Category",
              //     disabled:
              //       [undefined, null].includes(watchEmployment) ||
              //       employments.find((i) => i.id === watchEmployment)
              //         ?.categories.length === 0,
              //     fields: [
              //       {
              //         name: "category_id",
              //         label: "Select a category",
              //         type: "select-text-input",
              //         options: employments
              //           .find((i) => i.id === watchEmployment)
              //           ?.categories.map((cat) => ({
              //             value: cat.id,
              //             label: cat.name,
              //           })),
              //       },
              //       // {
              //       //   name: "note",
              //       //   label: "Note for the category",
              //       //   type: "text",
              //       // },
              //       ...(user.role === Roles.EMPLOYEE.value
              //         ? [
              //             {
              //               name: "hours",
              //               label: "Estimated hours",
              //               type: "numbers",
              //             },
              //           ]
              //         : []),
              //     ],
              //   },
              // ]
            : [
                {
                  name: "user.email",
                  type: "text",
                  label:
                    user.role === Role.EMPLOYER.value ? "Employee" : "Employer",
                  disabled: true,
                },
                {
                  name: "created_at",
                  type: "text",
                  label: "Request Date",
                  htmlType: "date",
                  disabled: true,
                },
              ]),
        ],
      },
    });
  }, [employments, watchEmployment, request]);

  const onSubmit = (values) => {
    values = {
      ...values,
      from_date: values.from_date.toISOString(),
      to_date: values.to_date.toISOString(),
    };
    if (request) {
      updateRequest(form.setError)({
        requestId: request.id,
        ...values,
      }).then((data) => {
        toast.success("The request has been updated.");
        setRequests((oldVal) =>
          oldVal.map((i) => {
            if (i.id === data.id) {
              return data;
            }
            return i;
          })
        );
        onClose();
      });
    } else {
      createRequest(form.setError)({
        ...values,
        categories: values.categories.reduce((acc, i) => {
          if (!acc.find((innerCat) => innerCat.category_id === i.category_id)) {
            acc.push(i);
          }
          return acc;
        }, []),
      }).then((data) => {
        toast.success("The request has been created.");
        setRequests((oldVal) => [...oldVal, ...data]);
        onClose();
        form.reset();
      });
    }
  };

  return (
    <AppModal
      open={open}
      onClose={() => {
        onClose();
        form.reset();
      }}
      title={
        request
          ? `${
              user.role === Role.EMPLOYER.value ? "Request" : "Commitment"
            } Information`
          : `Create a ${
              user.role === Role.EMPLOYER.value ? "request" : "commitment"
            }`
      }
    >
      <Form
        formDetails={formDetails.details}
        form={form}
        onSubmit={onSubmit}
        disabled={request && user.id !== request.created_by}
      />
      {request && (
        <Container style={{ marginTop: "20px" }}>
          <Row>
            <Col>
              <SecondaryButton
                onClick={() => {
                  onClose();
                  setAvailabilitiesModal({ open: true, id: request.id });
                }}
              >
                {user.role === Roles.EMPLOYEE.value &&
                request.created_by !== user.id
                  ? "Update availability"
                  : "Availability"}
              </SecondaryButton>
            </Col>
            {request && user.id === request.created_by && (
              <Col style={{ textAlign: "center" }}>
                <SecondaryButton
                  onClick={() =>
                    deleteRequest({ requestId: request.id }).then(() => {
                      setRequests((oldVal) =>
                        oldVal.filter((i) => i.id !== request.id)
                      );
                      onClose();
                      toast.success("The request has been deleted.");
                    })
                  }
                >
                  Delete
                </SecondaryButton>
              </Col>
            )}
          </Row>
        </Container>
      )}
    </AppModal>
  );
};
export default RequestForm;
